// Institute of Design and Innovation (email idi@unm.edu). //

/**
 * Individual Permission Values
 */
export default {
  canViewCalendar: 0,
  canManageCalendar: 1,
  canManageSystem: 2
}
